import React from 'react';
import { useData } from '../../context/DataContext';

export default function PanelSelector({ selectedPanel, onSelectPanel }) {
  const { data } = useData();
  if (!data) return null;

  const panelNames = Object.keys(data.panels);

  return (
    <div className="panel-selector">
      <label>Gene Panel</label>
      <div className="panel-buttons">
        {panelNames.map(name => (
          <button
            key={name}
            className={selectedPanel === name ? 'active' : ''}
            onClick={() => onSelectPanel(name)}
          >
            {name}
          </button>
        ))}
      </div>
    </div>
  );
}
